import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const SocketProvider = ({ children, url, auth }) => {
  const dispatch = useDispatch();
  const connected = useSelector((state) => state.socketReducer.connected);

  useEffect(() => {
    if (auth) {
      if (!connected) {
        dispatch({
          type: 'socket/connect',
          payload: { url, auth }
        });
      }
    } else {
      dispatch({ type: 'socket/disconnect' });
    }
  }, [dispatch, connected, url, auth]);

  useEffect(() => {
    return () => {
      dispatch({ type: 'socket/disconnect' });
    };
  }, [dispatch]);

  return children;
};

export default SocketProvider;